module.exports = require('./SidebarNavView');
